module.exports = require('./SidebarNavView');
